import React, {useState, Fragment, useRef, useContext, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import {Context} from '../../../Helpers/Auth';

import {Dialog, Transition} from '@headlessui/react';
import {ExclamationTriangleIcon} from '@heroicons/react/24/outline';

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import ExitForm from '../../ExitFormModal';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import MultiSelect from '../../Selects/MultiSelect';
import MultiSelectColor from '../../Selects/MultiSelectColor';
import CreateIcon from '@mui/icons-material/Create';
import EditCalendarRoundedIcon from '@mui/icons-material/EditCalendarRounded';
import KeyboardBackspaceRoundedIcon from '@mui/icons-material/KeyboardBackspaceRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import Datepicker from 'react-tailwindcss-datepicker';
import {getCategoriasReunioes, getDados, getRepresentantes, getStatusNegocio, getProspects, getMarcas, getTipos, getNacionaisInternacionais, getCategoriasArtigos} from '../../../pages/requests';
import SelectComponent from '../../Selects/SelectComponent';
import Prospects from '../../../pages/Prospects';

function DrawerFilter({
    setShowForm,
    showForm,

    setOpenTab,

    setEditarNegocio,
    editarNegocio,

    setNegocioSelecionado,
    negocioSelecionado,

    setOnChangeForm,
    onChangeForm,

    setGuardar,

    setNovoAgendamento,
    setNovaProposta,

    setFiltroEstado,
    filtroEstado,
    setFiltroRep,
    filtroRep,
    setFiltroPotencial,
    filtroPotencial,

    setFiltroCategoria,
    filtroCategoria,
    setFiltroMarca,
    filtroMarca,
    setFiltroNacionalInternacional,
    filtroNacionalInternacional,
    setFiltroFamilia,
    filtroFamilia,
    setFiltroStatusDt,
    filtroEtapa,
    filtroEmpresa,
    setFiltroEmpresa,
    filtroDt,
    filtroValor,
    setFiltroDt,
    setFiltroEtapa,
    filtroNome,
    setFiltroNome,
    setFiltroValor,
    filtroCodigo,
    setFiltroCodigo,
    etapas,
    openTab,
    filtroStatusDt,
}) {
    const FORMATO_DATA = 'YYYY-MM-DD';

    const {t} = useTranslation();
    const history = useHistory();
    const [open, setOpen] = useState(false);
    const [openExit, setOpenExit] = useState(false);
    const {utilizador, isCard, setIsCard, openCards, setOpenCards} = useContext(Context);
    const [probabilidadeFiltros, setProbabilidadeFiltros] = useState([]);
    const [categoriasArtigos, setCategoriasArtigos] = useState([]);
    const [nacionaisInternacionais, setNacionaisInternacionais] = useState([]);
    const [responsaveisTodos, setResponsaveisTodos] = useState([]);
    const [responsaveis, setResponsaveis] = useState([]);
    const [industriaFiltros, setIndustriaFiltros] = useState([]);
    const [probabilidade, setProbabilidade] = useState([]);
    const [sociedade, setSociedade] = useState([]);
    const [industria, setIndustria] = useState([]);
    const [estados, setEstados] = useState([]);
    const [contas, setContas] = useState([]);
    const [marcas, setMarcas] = useState([]);
    const [tipos, setTipos] = useState([]);
    const [isMobile, setIsMobile] = useState(false);

    const idiomaAtual = localStorage.getItem('i18nextLng');

    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const handleResize = () => {
        setIsMobile(window.innerWidth < 900);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    function limparFiltros(params) {
        setFiltroEstado(null);
        setFiltroRep([]);
        setFiltroPotencial(0);
        setFiltroCategoria(null);
        setFiltroMarca(null);
        setFiltroNacionalInternacional(null);
        setFiltroFamilia(null);
        setFiltroEtapa([]);
        setFiltroEmpresa('');
        setFiltroCodigo('');
        setFiltroNome('');
        setFiltroDt({startDate: null, endDate: null});
        setFiltroStatusDt({startDate: null, endDate: null});
        setFiltroValor(0);
    }

    function showButton(params) {
        if (
            filtroEstado ||
            filtroRep.length != 0 ||
            filtroPotencial != 0 ||
            filtroCategoria ||
            filtroMarca ||
            filtroNacionalInternacional ||
            filtroFamilia ||
            filtroEtapa.length != 0 ||
            filtroEmpresa ||
            filtroCodigo ||
            filtroNome ||
            filtroDt.startDate ||
            filtroStatusDt.startDate ||
            filtroValor
        ) {
            return true;
        } else {
            return false;
        }
    }

    // useEffect(() => {
    //     getRepresentantes(lang).then(res => {
    //         setResponsaveis(res.data.representantes);
    //         setResponsaveisTodos(res.data.representantes);
    //     });

    //     getMarcas(lang).then(res => {
    //         setMarcas(res.data.marcas);
    //     });

    //     getTipos(lang).then(res => {
    //         setTipos(res.data.tipos);
    //     });

    //     getNacionaisInternacionais(lang).then(res => {
    //         setNacionaisInternacionais(res.data.nacionaisInternacionais);
    //     });

    //     getCategoriasArtigos(lang).then(res => {
    //         setCategoriasArtigos(res.data.categorias);
    //     });
    // }, []);

    useEffect(() => {
        if (!utilizador) {
            return;
        }

        getStatusNegocio(lang).then(res => {
            setEstados(res.data.status);
        });

        getDados(lang).then(res => {
            var comps2 = [];

            res.data.industria.forEach(element => {
                const industriaR = {
                    value: element.id,
                    label: element.descricao,
                };
                comps2.push(industriaR);
            });
            setIndustriaFiltros(comps2);
            setIndustria(comps2);
            var comps3 = [];
            res.data.probabilidadeNegocio.forEach(element => {
                const pN = {
                    value: element.id,
                    label: element.descricao,
                };
                comps3.push(pN);
            });
            setProbabilidadeFiltros(comps3);
            setProbabilidade(comps3);
            var comps4 = [];
            res.data.sociedade.forEach(element => {
                const sN = {
                    value: element.id,
                    label: element.descricao,
                };
                comps4.push(sN);
            });
            setSociedade(comps4);
        });
    }, [utilizador]);

    function GetContas(pesquisa) {
        if (pesquisa.length >= 3) {
            getProspects(0, 9999, lang, pesquisa, '', '', '', '').then(res => {
                setContas(
                    res.data.clientes.map(c => {
                        return {
                            ...c,
                            value: c.codigoCliente,
                            label: c.nomeCliente,
                        };
                    }),
                );
            });
        } else {
            setContas([]);
        }
    }

    const [state, setState] = useState({
        right: false,
    });

    const toggleDrawer = (anchor, open) => event => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({...state, [anchor]: open});
    };

    const closeDrawer = anchor => {
        setState({...state, [anchor]: false});
    };

    const handleResponsaveisClick = () => {
        if (responsaveis.length == 0) {
            getRepresentantes(lang).then(res => {
                setResponsaveis(res.data.representantes);
            });
        }
    };

    const handleMarcasClick = () => {
        if (marcas.length == 0) {
            getMarcas(lang).then(res => {
                setMarcas(res.data.marcas);
            });
        }
    };

    const handleTiposClick = () => {
        if (tipos.length == 0) {
            getTipos(lang).then(res => {
                setTipos(res.data.tipos);
            });
        }
    };

    const handleNacionaisInternacionaisClick = () => {
        if (nacionaisInternacionais.length == 0) {
            getNacionaisInternacionais(lang).then(res => {
                setNacionaisInternacionais(res.data.nacionaisInternacionais);
            });
        }
    };

    const handleCategoriasArtigosClick = () => {
        if (categoriasArtigos.length == 0) {
            getCategoriasArtigos(lang).then(res => {
                setCategoriasArtigos(res.data.categorias);
            });
        }
    };

    const list = anchor => (
        <ClickAwayListener onClickAway={() => closeDrawer(anchor)}>
            <Box sx={{width: 320}} role="presentation" className="h-full  bg-white w-80 dark:bg-gray-800 overflow-y-scroll ">
                <h5 id="drawer-label" className="inline-flex p-4 items-center mb-2 text-base font-semibold text-blue-600 uppercase dark:text-blue-600">
                    <FilterAltIcon className="mr-2" />
                    {t('filtros')}
                </h5>
                <button
                    type="button"
                    data-drawer-hide="drawer-contact"
                    aria-controls="drawer-contact"
                    onClick={() => closeDrawer(anchor)}
                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-blue-600 rounded-[8px] text-sm w-8 h-8 absolute top-2.5 right-2.5 inline-flex items-center justify-center dark:hover:bg-blue-600 dark:hover:text-white">
                    <CloseIcon />
                    <span className="sr-only">Close menu</span>
                </button>
                <div className=" p-4">
                    <div className="mb-2">
                        <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('estado')}
                        </label>
                        <SelectComponent
                            options={estados}
                            value={filtroEstado}
                            onChange={e => {
                                setFiltroEstado(e);
                            }}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('selecioneOpcao')}
                        />
                    </div>
                    <div className="mb-2">
                        <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('dataEstado')}
                        </label>
                        <Datepicker
                            displayFormat={FORMATO_DATA}
                            useRange={false}
                            // asSingle={true}
                            value={filtroStatusDt}
                            onChange={newValue => {
                                setFiltroStatusDt(newValue);
                            }}
                            inputClassName={`rounded-[8px] w-full bg-gray-50 border border-gray-300 text-lg text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                        />
                    </div>
                    <div className="mb-2">
                        <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('gestorCliente')}
                        </label>
                        <MultiSelect
                            options={responsaveis}
                            value={filtroRep}
                            onChange={e => {
                                setFiltroRep(e);
                            }}
                            onMenuOpen={handleResponsaveisClick}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('selecioneOpcao')}
                        />
                    </div>

                    <div className="mb-2">
                        <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('potencial')}
                        </label>
                        <SelectComponent
                            options={probabilidadeFiltros}
                            value={filtroPotencial}
                            onChange={e => {
                                setFiltroPotencial(e);
                            }}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('selecioneOpcao')}
                        />
                    </div>

                    <div className="mb-2">
                        <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('categoria')}
                        </label>
                        <SelectComponent
                            options={categoriasArtigos}
                            value={filtroCategoria}
                            onChange={e => {
                                setFiltroCategoria(e);
                            }}
                            onMenuOpen={handleCategoriasArtigosClick}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('selecioneOpcao')}
                        />
                    </div>
                    <div className="mb-2">
                        <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('marca')}
                        </label>
                        <SelectComponent
                            options={marcas.filter(o => o.dep === filtroCategoria?.value)}
                            value={filtroMarca}
                            onChange={e => {
                                setFiltroMarca(e);
                            }}
                            onMenuOpen={handleMarcasClick}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('selecioneOpcao')}
                        />
                    </div>
                    <div className="mb-2">
                        <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('nacionalInternacional')}
                        </label>
                        <SelectComponent
                            options={nacionaisInternacionais.filter(o => o.dep === filtroMarca?.value)}
                            value={filtroNacionalInternacional}
                            onChange={e => {
                                setFiltroNacionalInternacional(e);
                            }}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('selecioneOpcao')}
                            onMenuOpen={handleNacionaisInternacionaisClick}
                        />
                    </div>
                    <div className="mb-2">
                        <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('familia')}
                        </label>
                        <SelectComponent
                            options={tipos.filter(o => o.dep === filtroNacionalInternacional?.value)}
                            value={filtroFamilia}
                            onMenuOpen={handleTiposClick}
                            onChange={e => {
                                setFiltroFamilia(e);
                            }}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('selecioneOpcao')}
                            onInputChange={e => GetContas(e)}
                        />
                    </div>
                    <div className="mb-2">
                        <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('etapa')}
                        </label>
                        <MultiSelect
                            options={etapas}
                            value={filtroEtapa}
                            onChange={e => {
                                setFiltroEtapa(e);
                            }}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('selecioneOpcao')}
                        />
                    </div>
                    <div className="mb-2">
                        <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('empresa')}
                        </label>

                        <input
                            type="text"
                            value={filtroEmpresa}
                            className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 
                            } `}
                            onChange={e => {
                                setFiltroEmpresa(e.target.value);
                            }}
                            placeholder={t('filtro')}
                        />
                    </div>
                    <div className="mb-2">
                        <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('codigo')}
                        </label>

                        <input
                            type="text"
                            value={filtroCodigo}
                            className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 
                            } `}
                            onChange={e => {
                                setFiltroCodigo(e.target.value);
                            }}
                            placeholder={t('filtro')}
                        />
                    </div>
                    <div className="mb-2">
                        <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('nome')}
                        </label>

                        <input
                            type="text"
                            value={filtroNome}
                            className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 
                            } `}
                            onChange={e => {
                                setFiltroNome(e.target.value);
                            }}
                            placeholder={t('filtro')}
                        />
                    </div>
                    {/* <div className="mb-2">
                        <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('empresa')}
                        </label>

                        <input
                            type="text"
                            value={filtroFamilia}
                            className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 
                            } `}
                            onChange={e => {
                                setFiltroFamilia(e.target.value);
                            }}
                            placeholder={t('filtro')}
                        />
                    </div> */}
                    <div className="mb-2">
                        <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('dataCriacao')}
                        </label>

                        <Datepicker
                            displayFormat={FORMATO_DATA}
                            useRange={false}
                            // asSingle={true}
                            value={filtroDt}
                            onChange={newValue => {
                                setFiltroDt(newValue);
                            }}
                            inputClassName={`rounded-[8px] w-full bg-gray-50 border border-gray-300 text-lg text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                        />
                    </div>
                    <div className="mb-2">
                        <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('valor')}
                        </label>

                        <input
                            type="number"
                            value={filtroValor}
                            className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 
                            } `}
                            onChange={e => {
                                setFiltroValor(e.target.value);
                            }}
                            placeholder={t('filtro')}
                        />
                    </div>

                    {showButton() && (
                        <div className="flex flex-row justify-end">
                            <button
                                type="button"
                                onClick={() => limparFiltros()}
                                className="flex items-center font-semibold text-sm justify-center text-white bg-red-700 rounded-[8px] py-1 px-2 hover:bg-red-800 dark:bg-red-600 dark:hover:bg-red-700 focus:ring-4 focus:ring-red-300 focus:outline-none dark:focus:ring-red-800">
                                {t('limparFiltros')} <CloseRoundedIcon />
                            </button>
                        </div>
                    )}
                </div>
            </Box>
        </ClickAwayListener>
    );

    return (
        <>
            {' '}
            <div className="flex flex-row items-center">
                {(openTab == 5 || !showForm || openTab == 4) && (
                    <>
                        {!isMobile && (
                            <>
                                <div className="flex items-center mr-3">
                                    <label className="relative inline-flex items-center cursor-pointer">
                                        <input type="checkbox" checked={isCard} onChange={() => setIsCard(!isCard)} className="sr-only peer" />
                                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                        <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('modoCard')}</span>
                                    </label>
                                </div>
                            </>
                        )}
                        {isCard && (
                            <div className="flex items-center mr-3">
                                <label className="relative inline-flex items-center cursor-pointer">
                                    <input type="checkbox" checked={openCards} onChange={() => setOpenCards(!openCards)} className="sr-only peer" />
                                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                    <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('abrirCards')}</span>
                                </label>
                            </div>
                        )}
                    </>
                )}

                <div className="inline-flex mb-4 rounded-[8px] shadow-sm" role="group">
                    {/* botão para abrir filtros */}
                    {!showForm && (
                        <button
                            title={t('filtros')}
                            type="button"
                            onClick={toggleDrawer('right', true)}
                            className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-200 rounded-l-[8px] hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white">
                            <FilterAltIcon />
                        </button>
                    )}
                    {/* Botão de voltar */}
                    {showForm && (
                        <button
                            type="button"
                            title={t('voltar')}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10  dark:bg-blue-700 text-blue-700 focus:ring-blue-700 focus:ring-2 rounded-l-[8px] dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white`}
                            onClick={() => {
                                if (onChangeForm) {
                                    //se existirem alterações no formulario abre popup para perguntar se quer sair
                                    setOpenExit(true);
                                    // setOnChangeForm(false);
                                } else {
                                    setShowForm(false);
                                    setEditarNegocio(false);
                                    // setOnChangeForm(false);
                                    setNegocioSelecionado(null);
                                    setOpenTab(1);
                                }
                                //handleShowForm(showForm);
                            }}>
                            {<KeyboardBackspaceRoundedIcon />}
                        </button>
                    )}

                    {/* Botão de criar negocio */}
                    {!showForm && (
                        <button
                            type="button"
                            title={t('criarNegocio')}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10 dark:bg-gray-700 text-gray-500 rounded-r-[8px] dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white`}
                            onClick={() => {
                                setShowForm(true);
                                setEditarNegocio(true);
                                setOnChangeForm(false);
                                setNegocioSelecionado(null);
                                setOpenTab(3);
                            }}>
                            {<NoteAddIcon />}
                        </button>
                    )}

                    {/* Botão para criar proposta */}
                    {showForm && negocioSelecionado && (
                        <button
                            type="submit"
                            title={t('criarProposta')}
                            onClick={() => {
                                setNovaProposta(true);
                            }}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border  border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10   dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white `}>
                            {<PostAddOutlinedIcon />}
                        </button>
                    )}

                    {/* botao para criar uma reuniao/interação */}
                    {showForm && negocioSelecionado && (
                        <button
                            title={t('criarReuniaoVisita')}
                            type="submit"
                            onClick={() => {
                                setNovoAgendamento(true);
                            }}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border  border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10   dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white`}>
                            <EditCalendarRoundedIcon />
                        </button>
                    )}

                    {/* Botao para ativar a edição */}
                    {showForm && !editarNegocio && (
                        <button
                            type="submit"
                            title={t('editar')}
                            onClick={() => {
                                setEditarNegocio(true);
                            }}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border  border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10   dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white rounded-r-[8px] `}>
                            {<CreateIcon />}
                        </button>
                    )}

                    {/* botao para guardar */}
                    {showForm && editarNegocio && (
                        <button
                            type="submit"
                            title={t('salvar')}
                            onClick={() => {
                                setGuardar(true);
                            }}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border  border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10   dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white rounded-r-[8px] `}>
                            {negocioSelecionado ? <SaveAsIcon /> : <SaveIcon />}
                        </button>
                    )}
                </div>
            </div>
            <Drawer anchor="right" open={state['right']} onClose={toggleDrawer('right', false)}>
                {list('right')}
            </Drawer>
            {/* Formulario de confirmação de saida */}
            {openExit && (
                <ExitForm
                    cancelar={() => setOpenExit(false)}
                    back={() => {
                        setOpenExit(false);

                        setShowForm(false);
                        setEditarNegocio(false);
                        setOnChangeForm(false);
                        setNegocioSelecionado(null);
                        setOpenTab(1);
                    }}
                />
            )}
        </>
    );
}

export default DrawerFilter;
